export default {"src":"/_next/static/media/ic-filter.f0ace973.svg","height":24,"width":24};